import React, { useState, useEffect } from "react";
import { Eye, Heart, MessageCircle, Sparkles, Newspaper, GraduationCap, Stethoscope } from "lucide-react";
import { Link } from "react-router-dom";
import { API_URL } from "../AuthContext";

const KIND_CONFIG = {
  post:    { path: "articles", label: "Статья", icon: Newspaper },
  case:    { path: "cases", label: "Случай", icon: Stethoscope },
  lecture: { path: "lectures", label: "Материал", icon: GraduationCap },
};

export default function AuthorStats({ token }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/authors/me/stats`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(setStats)
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return null;
  if (!stats || stats.items.length === 0) return null; // не автор ни одного материала — секцию не показываем

  return (
    <div className="card" style={{ marginBottom: 18 }}>
      <h3 className="admin-section-title" style={{ marginTop: 0 }}>Статистика по моим публикациям</h3>

      <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: "1.4rem", fontWeight: 700, color: "#007c84" }}>{stats.total_views}</div>
          <div style={{ fontSize: "0.8rem", color: "#888" }}>просмотров всего</div>
        </div>
        <div>
          <div style={{ fontSize: "1.4rem", fontWeight: 700, color: "#007c84" }}>{stats.total_likes}</div>
          <div style={{ fontSize: "0.8rem", color: "#888" }}>реакций</div>
        </div>
        <div>
          <div style={{ fontSize: "1.4rem", fontWeight: 700, color: "#007c84" }}>{stats.total_comments}</div>
          <div style={{ fontSize: "0.8rem", color: "#888" }}>комментариев</div>
        </div>
        <div>
          <div style={{ fontSize: "1.4rem", fontWeight: 700, color: "#e5005b" }}>{stats.total_citations || 0}</div>
          <div style={{ fontSize: "0.8rem", color: "#888" }}>раз в ответах ИИ-поиска</div>
        </div>
        <div>
          <div style={{ fontSize: "1.4rem", fontWeight: 700, color: "#007c84" }}>{stats.items.length}</div>
          <div style={{ fontSize: "0.8rem", color: "#888" }}>публикаций</div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {stats.items.map(item => {
          const cfg = KIND_CONFIG[item.kind];
          const Icon = cfg.icon;
          return (
            <Link key={`${item.kind}_${item.id}`} to={`/${cfg.path}/${item.id}`}
              style={{
                display: "flex", alignItems: "center", gap: 10, padding: "8px 10px",
                borderRadius: 8, textDecoration: "none", color: "inherit",
                background: "var(--surface-alt, #f7f8fc)",
              }}>
              <Icon size={15} strokeWidth={2.2} color="#e5005b" style={{ flexShrink: 0 }} />
              <span style={{ flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "0.92rem" }}>
                {item.title}
              </span>
              <span style={{ display: "flex", alignItems: "center", gap: 3, fontSize: "0.82rem", color: "#888", flexShrink: 0 }}>
                <Eye size={13} strokeWidth={2.2} /> {item.views}
              </span>
              <span style={{ display: "flex", alignItems: "center", gap: 3, fontSize: "0.82rem", color: "#888", flexShrink: 0 }}>
                <Heart size={13} strokeWidth={2.2} /> {item.likes}
              </span>
              <span style={{ display: "flex", alignItems: "center", gap: 3, fontSize: "0.82rem", color: "#888", flexShrink: 0 }}>
                <MessageCircle size={13} strokeWidth={2.2} /> {item.comments}
              </span>
              {item.citations > 0 && (
                <span style={{ display: "flex", alignItems: "center", gap: 3, fontSize: "0.82rem", color: "#e5005b", flexShrink: 0 }}>
                  <Sparkles size={13} strokeWidth={2.2} /> {item.citations}
                </span>
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
